import React, { useState } from "react";
import "./RoleCreationPopup.css";
import { createRole } from "../../services/employeeService";
import Popup from "../../components/ui/Popup"; // ✅ Success/Error Popup

const RoleCreationPopup = ({ isOpen, onClose, onRoleAdded }) => {
    const [roleName, setRoleName] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!roleName.trim()) {
            // setErrorMessage();
            setPopupMessage("Role name is required.".join("\n")); // ✅ Show all errors in the popup
            setShowPopup(true);
        }

        try {
            await createRole({ role_name: roleName });

            setPopupMessage("Role Succefully Inserted."); // ✅ Show all errors in the popup
            setShowPopup(true);
            setTimeout(() => {
                setShowPopup(false);
                onClose();
                onRoleAdded(); // ✅ Refresh employee list
            }, 2000);
             // ✅ Refresh roles list
        } catch (error) {
            console.error("Error creating role:", error);
            setErrorMessage("Failed to create role.");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="role-popup-overlay">
            <div className="role-popup-content">
                <button className="role-close-btn" onClick={onClose}>✕</button>
                <h2>Create New Role</h2>

                <form onSubmit={handleSubmit}>
                    <div className="role-form-group">
                        <label>Role Name:</label>
                        <input
                            type="text"
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}
                            placeholder="Enter role name"
                        />
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                    </div>
                    <button type="submit" className="create-role-btn">Create Role</button>
                </form>
            </div>{/* ✅ Popup Notification for Validation Errors & Success Messages */}
            {showPopup && <Popup message={popupMessage} onClose={() => setShowPopup(false)} />}

        </div>
    );
};

export default RoleCreationPopup;
